'use client'
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import { useAuth } from "../Contexts/AuthenticateProvider"
import Handler from "../Helpers/Handler";
import { MdLogout } from "react-icons/md";

const Header = () => {
  const { logOut } = useAuth()
  const [profile, setProfileDetails] = useState(true)
  const [width, setWidth] = useState(1140)
  const logOutCall = async () => {
    const response = await Handler({ method: 'POST', url: "/customer/logout", data: {} })
    if (response?.success) {
      toast.success(response?.message);
      setTimeout(() => {
        logOut()
      }, 1500);
    } else {
      toast.error(response?.message)
    }
  }
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  useEffect(() => {
    if (width < 992) {
      setProfileDetails(false)
    } else {
      setProfileDetails(true)
    }
  }, [width])

  return (
    <React.Fragment>
      <header className="header-section">
        <Container fluid>
          <Row className="mx-sm-2 my-0 p-sm-2 py-3">
            <Col className="d-flex justify-content-between align-items-center">
              <span><a href={"/"}><img className="logo me-2 img-responsive" src={'https://madrasselfdrivecars.com//static/new-logo-1-00879a3ea5e8ebf6041815cdbc495ea4.svg'} alt="logo" /></a></span>
              <button className="btn btn-danger d-flex align-items-center justify-content-center gap-1" onClick={logOutCall} >
                <MdLogout />
                <span>Logout</span>
              </button>
              {/* <Dropdown
                isOpen={menu}
                toggle={() => setMenu(!menu)}
                className="d-inline-block ms-lg-5"
              >
                <DropdownToggle
                  className="btn p-1 d-flex justify-center align-items-center"
                  id="page-header-user-dropdown"
                  tag="button" >
                  <div className="d-flex align-items-center">
                    {!profileDetails?.cust_photo ?
                      <img className="profile-image me-2" src={User} alt="profile-image" />
                      :
                      <img className="profile-image" width={80} height={80} src={profileDetails?.cust_photo} alt="customer-profile" />
                    } <span className="fw-bold ms-2 d-none d-sm-inline-block">{(profileDetails?.cust_name) ? textCapital(profileDetails?.cust_name?.split(' ')[0]) : "Buddy"} </span> </div>
                  <div className='d-flex justify-center align-items-center ms-2'><i className="bi bi-chevron-down "></i></div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem tag="button" onClick={()=>navigate("/profile")} className="cursor-pointer font-w-300 px-3 py-2">
                    <FaUserCircle className="me-2" />
                    <span>Profile</span>
                  </DropdownItem>
                  <DropdownItem tag="button" onClick={logOutCall} className="cursor-pointer font-w-300 px-3 py-2">
                    <i className="bi bi-box-arrow-left me-2"></i>
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </Col>
          </Row>
        </Container>
      </header>
      {/* <Offcanvas isOpen={show} toggle={toggleCanvas} fade>
        <OffcanvasHeader toggle={toggleCanvas}>
        </OffcanvasHeader>
        <OffcanvasBody>
          <div className="d-flex flex-column justify-content-center">
            <div className="text-center">{profileDetails?.cust_photo ? <img className="profile-image" src={profileDetails?.cust_photo} alt="customer-profile" /> : <img className="profile-image me-2" src={User} alt="profile-image" />}</div>
            <div className="text-center fs-4 my-2">{(profileDetails?.cust_name) ? textCapital(profileDetails?.cust_name) : "User"}</div>
          </div>
          <div className="ms-3">
            <ul className="route-list">
              <li><a href="/" className={router.pathname === "/dashboard" ? "active" : ""}><span className="mx-2"><i className="fa-solid fa-house"></i></span>Home</a></li>
              <li><a href="/profile" className={router.pathname === "/profile" ? "active" : ""}><span className="mx-2"><i className="fa-solid fa-user"></i></span>Profile</a></li>
              <li><a href="/bookings" className={router.pathname === "/bookings" ? "active" : ""}><span className="mx-2"><i className="fa-solid fa-book"></i></span>My Bookings</a></li>
              <li><Button color="link" className="logout-btn" onClick={logOutCall}><span className="mx-2"><i className="fa-solid fa-power-off"></i></span>Logout</Button></li>
            </ul>
          </div>
        </OffcanvasBody>
      </Offcanvas> */}
    </React.Fragment>
  );
};

export default Header;